<template>
  <div
    class="flex min-h-screen flex-col items-center justify-between bg-dark-blue-darkest"
  >
    <div class="w-[90vw] md:w-[80vw]">
      <UHeader :dark="false" />
      <main>
        <slot />
      </main>
    </div>
    <UMarketingFooter />
  </div>
</template>
